module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-container"
  }, [_c('ul', {
    staticClass: "drag-list"
  }, _vm._l((_vm.stages), function(stage) {
    return _c('li', {
      key: stage,
      staticClass: "drag-column",
      class: ( _obj = {}, _obj['drag-column-' + stage] = true, _obj )
    }, [_c('span', {
      staticClass: "drag-column-header"
    }, [_vm._t(stage, [_c('h2', [_vm._v(_vm._s(stage))])])], 2), _vm._v(" "), _c('div', {
      staticClass: "drag-options"
    }), _vm._v(" "), _c('ul', {
      ref: "list",
      refInFor: true,
      staticClass: "drag-inner-list",
      attrs: {
        "data-status": stage
      }
    }, _vm._l((_vm.getBlocks(stage)), function(block) {
      return _c('li', {
        key: block[_vm.idProp],
        staticClass: "drag-item",
        attrs: {
          "data-block-id": block[_vm.idProp]
        }
      }, [_vm._t(block[_vm.idProp], [_c('strong', [_vm._v(_vm._s(block[_vm.statusProp]))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(block[_vm.idProp]))])])], 2)
    })), _vm._v(" "), _c('div', {
      staticClass: "drag-column-footer"
    }, [_vm._t(("footer-" + stage))], 2)])
    var _obj;
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68a87a36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kanban.vue
// module id = 1118
// module chunks = 1